export class LanguageForm {
   constructor(form) {
       this.form = form;
       this.select = form.querySelector('select');

       this.select.addEventListener('change', (event) => {
           this.form.submit();
       });
   }
}

let forms = document.querySelectorAll('.language-form');
[...forms].forEach((form) => new LanguageForm(form));




// WEBPACK FOOTER //
// ./src/my_artis/js/components/language.js